import { HTML_FONT_SIZE } from '../constants'
import { createTheme } from '@mui/material/styles'
const theme = createTheme()

const fonts = {
  htmlFontSize: HTML_FONT_SIZE,
  fontFamily: ['Arial', 'sans-serif'].join(','),
  h1: {
    fontFamily: 'ActoBold',
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 1.1667,
    letterSpacing: 0.25,
    [theme.breakpoints.up('sm')]: {
      fontSize: 24,
    },
  },
  h2: {
    fontFamily: 'ActoBold',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 1.2,
    letterSpacing: 0.5,
    [theme.breakpoints.up('sm')]: {
      fontSize: 20,
    },
  },
  h3: {
    fontFamily: 'ActoBold',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 1.1875,
    letterSpacing: 0.5,
  },
  h3medium: {
    fontFamily: 'ActoMedium',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 1.1875,
    letterSpacing: 0.5,
  },
  h4: {
    fontFamily: 'ActoMedium',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 1.2142,
  },
  h4bold: {
    fontFamily: 'ActoBold',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 1.2142,
  },
  body1: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.15,
  },
  body2: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 1.33,
  },
  subtitle1: {
    fontWeight: 400,
    fontSize: 10,
    lineHeight: 1.15,
  },
  inputText: {
    fontFamily: 'ActoMedium',
    fontWeight: 500,
    fontSize: 16,
    lineHeight: 1.1875,
  },
  label: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 1.1667,
  },
}

export default fonts
